module.exports = "/assets/data/6fa2ff3d136dd5f4412bedd03635e293-DN40.data.json";